export default class DataModel extends PIXI.utils.EventEmitter{
    constructor(data, msg){
        super();
        const keys = Object.keys(data);
        var _self = this;
        keys.forEach(key => {
            Object.defineProperty( _self, key, {
                get: function () {
                    return data[key];
                },
                set: function(value) {
                    if(value === data[key]){return;}
                    data[key] = value;
                    _self.emit(key, value);
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/common/scripts/pixi/DataModel.js